import React from 'react';

import QueryErrorState from 'components/DesignSystem/QueryErrorState';
import { OverviewErrorKind } from 'hooks/Meteorology/Agro/Overview/Dashboard/useOverviewErrorState';

import './index.scss';

const MESSAGES: Record<OverviewErrorKind, string> = {
  network: 'Verifique sua conexão e tente novamente.',
  server: 'O serviço está indisponível no momento. Tente novamente em instantes.',
  forbidden: 'Você não tem permissão para ver esta informação.',
};

/**
 * Aviso de falha de UMA parte da Visão Geral, no lugar dela (#2009, item 2): as outras
 * partes continuam na tela. `label` nomeia a região para leitores de tela.
 */
export default function PartErrorState({
  label,
  subject,
  kind,
  onRetry,
  className = '',
}: {
  label: string;
  /** Complemento de "Não foi possível carregar…", ex.: "os indicadores". */
  subject: string;
  kind: OverviewErrorKind;
  onRetry: () => void;
  className?: string;
}) {
  return (
    <section aria-label={label} className={`agro-overview-part-error ${className}`.trim()}>
      <QueryErrorState
        title={`Não foi possível carregar ${subject}`}
        message={MESSAGES[kind]}
        onRetry={onRetry}
      />
    </section>
  );
}
